module.exports = __webpack_public_path__ + "img/banner-service-bg.3d39e835.jpeg";